<template>
    <div>
        <sau-page-nav :components="components"></sau-page-nav>
    </div>
</template>
<script>
export default {
    data() {
        return {
            capabilities: {
                deviceInfo: false
            },
            components: {
                'Login Details': 'service/common/_Access',
                'IPMI Console': 'service/dedi/_IpmiConsole',
                'Guest IPMI Access': 'service/dedi/_IpmiGuest',
            }
        }
    },
    created() {
        this.fetchDeviceInfo();
    },
    methods: {
        fetchDeviceInfo() {
            this.getRequest(`/api/v2/services/${this.getServiceId()}/public-ipmi`)
                .then((response) => {
                    this.capabilities.deviceInfo = response.data;
                }).catch((error) => {
                    console.log(error);
                })
        }
    }
}
</script>
<style>
</style>